import CryptoJS from 'crypto-js';

// 加密算法配置（与Java保持一致）
// const AES_ALGORITHM = 'AES-CBC';
// 密钥（与Java保持一致，16字节）
const KEY = 'a1b2c3d4e5f6g7h8';
// 初始化向量IV（与Java保持一致，16字节）
const IV = 'h8g7f6e5d4c3b2a1';

/**
 * 将字符串转换为CryptoJS可用的WordArray（模拟Java的UTF8字节数组）
 * @param {string} str 原始字符串
 * @returns {CryptoJS.lib.WordArray} WordArray对象
 */
function stringToUtf8WordArray(str) {
  return CryptoJS.enc.Utf8.parse(str);
}

/**
 * 将WordArray转换为UTF8字符串
 * @param {CryptoJS.lib.WordArray} wordArray WordArray对象
 * @returns {string} UTF8字符串
 */
function wordArrayToUtf8String(wordArray) {
  return CryptoJS.enc.Utf8.stringify(wordArray);
}

/**
 * 加密用户信息（完全对齐Java的encryptUserInfo逻辑）
 * @param {string} userInfoJson 原始用户信息JSON字符串
 * @returns {string} 最终的Base64编码加密字符串
 */
export function encryptUserInfo(userInfoJson) {
  try {
    // 1. JSON字符串转UTF8 WordArray（对应Java的getBytes(UTF_8)）
    const jsonWordArray = stringToUtf8WordArray(userInfoJson);
    
    // 2. Base64编码（对应Java的Base64.getEncoder().encode）
    const base64Str = CryptoJS.enc.Base64.stringify(jsonWordArray);
    const base64WordArray = stringToUtf8WordArray(base64Str);
    
    // 3. AES-CBC加密
    const keyWordArray = stringToUtf8WordArray(KEY);
    const ivWordArray = stringToUtf8WordArray(IV);
    const encrypted = CryptoJS.AES.encrypt(base64WordArray, keyWordArray, {
      iv: ivWordArray,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7 // PKCS5Padding和PKCS7Padding在16字节块下等价
    });
    
    // 4. 组合IV和加密数据（IV前置，对应Java的System.arraycopy）
    const ivBytes = ivWordArray.words;
    const encryptedBytes = encrypted.ciphertext.words;
    const finalEncryptedWords = [...ivBytes, ...encryptedBytes];
    const finalEncryptedWordArray = CryptoJS.lib.WordArray.create(finalEncryptedWords);
    
    // 5. 再次Base64编码并转字符串
    return CryptoJS.enc.Base64.stringify(finalEncryptedWordArray);
  } catch (error) {
    console.error('加密失败：', error);
    throw new Error('用户信息加密失败');
  }
}

/**
 * 解密用户信息（完全对齐Java的decodeUserInfo逻辑）
 * @param {string} encryptedBase64Str 加密后的Base64字符串
 * @returns {string} 原始的用户信息JSON字符串
 */
export function decodeUserInfo(encryptedBase64Str) {
  try {
    // 1. Base64解码（对应Java的Base64.getDecoder().decode）
    const encryptedWordArray = CryptoJS.enc.Base64.parse(encryptedBase64Str);
    const encryptedBytes = encryptedWordArray.words;
    
    // 2. 分离IV和加密数据（前16字节是IV，16字节=4个Word，每个Word占4字节）
    const ivWords = encryptedBytes.slice(0, 4); // 前4个Word = 16字节
    const realEncryptedWords = encryptedBytes.slice(4); // 剩余部分是加密数据
    const ivWordArray = CryptoJS.lib.WordArray.create(ivWords);
    const realEncryptedWordArray = CryptoJS.lib.WordArray.create(realEncryptedWords);
    
    // 3. AES-CBC解密
    const keyWordArray = stringToUtf8WordArray(KEY);
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: realEncryptedWordArray },
      keyWordArray,
      {
        iv: ivWordArray,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    
    // 4. Base64解码并转UTF8字符串
    const decryptedBase64Str = wordArrayToUtf8String(decrypted);
    const finalWordArray = CryptoJS.enc.Base64.parse(decryptedBase64Str);
    return wordArrayToUtf8String(finalWordArray);
  } catch (error) {
    console.error('解密失败：', error);
    throw new Error('用户信息解密失败');
  }
}